import React from 'react'
import SVG from 'react-inlinesvg'
import { toAbsoluteUrl } from '../../../utils/toAbsolutePath';
type Props = {
  className?: string
  path: string
  svgClassName?: string
}

/**
 * Helper para renderizar SVGs inline desde la carpeta public.
 * Usa `react-inlinesvg` con ruta resuelta via `toAbsoluteUrl`.
 */
const KTSVG: React.FC<Props> = ({className = '', path, svgClassName = 'mh-50px'}) => {
  return (
    <span className={`svg-icon ${className}`}>
      <SVG src={toAbsoluteUrl(path)} className={svgClassName} />
    </span>
  )
}

export {KTSVG}
